import React, {Component} from "react";
import SimpleReactValidator from "simple-react-validator";

/* Import Components */
import Input from "./Input";
import Select from "./Select";
import Button from "./Button";
import EmailInput from "./EmailInput";
import RadioButton from "./RadioButton";
import TelephoneInput from "./TelephoneInput";
import Confirmation from "./Confirmation";
import TextArea from "./TextArea";

import FetchHelper from "./helpers/FetchHelper";
import CheckBox from "./CheckBox";
import ResearchDisclaimer from "./ResearchDisclaimer";

class TFTReferral extends Component {
    constructor(props) {
        super(props);

        this.state = {
            initialState: true,
            newUser: {system: "TFT"},
            genderOptions: ["Male", "Female", "Non-binary", "Prefer not to say"],
            allOrgs: [],
            orgOptions: [],
            serviceOptions: [],
            deptOptions: [],
            radioOptions: ["Yes", "No"],
            issueOptions: ["Personal", "Work", "Both"],
            enquiryOptions: props.enquiryOptions || [],
            fullPartTimeOptions: ["Full Time", "Part Time", "Prefer not to say"],
            howHearOptions: props.howHearOptions || [],
            referrerOptions: props.referrerOptions || [],
            lengthOfServiceOptions: props.lengthOfServiceOptions || [],
            professionalMixOptions: props.professionalMixOptions || [],
            issueGroupOptions: props.issueGroupOptions || [],
            issuePersonalGroupOptions: props.issuePersonalGroupOptions || [],
            issueWorkGroupOptions: props.issueWorkGroupOptions || [],
            yesMaybeNo: ["Yes", "Maybe", "No"],
            yesMaybeNoOther: ["Yes", "No", "Maybe", "Other"],
            supportTypeOptions: props.supportTypeOptions || [],
        };


        const validateNumber = (phone_number, isMobile = false) => {
            if (isMobile && (!phone_number || phone_number.length === 0)) {
                return {
                    valid: false,
                    message: "Mobile phone number is required"
                }
            } else if (!phone_number || phone_number.length === 0) {
                return {
                    valid: true,
                    message: "phone number not required"
                }
            } else {
                if (phone_number?.startsWith('07') || phone_number?.startsWith('+44')) {
                    let numberLength = phone_number.length || 0
                    if (phone_number?.startsWith('0')) {
                        if (numberLength !== 11) {
                            return {
                                valid: false,
                                message: `UK phone number starting with (0) must be 11 characters, currently ${numberLength} chars.`
                            }
                        }
                    }
                    if (phone_number?.startsWith('+44')) {
                        if (numberLength !== 13) {
                            return {
                                valid: false,
                                message: `UK phone number starting with (+44) must be 13 characters, currently ${numberLength} chars`
                            }
                        }
                    }
                    if (!phone_number?.match(/^[+0-9]*$/)) {
                        return {
                            valid: false,
                            message: "A phone number can only have numbers or +"
                        }
                    }
                } else {
                    return {
                        valid: false,
                        message: `UK phone number must start with either (+44) or (07)`
                    }
                }
            }
            return {
                valid: true,
            }
        }
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            locale: "en",
            className: "text-danger",
            validators: {
                custom_phone_number: {
                    message: ':replaced',
                    rule: (val, params, validator) => {
                        return validateNumber(val).valid
                    },
                    messageReplace: (message, params) => {
                        return validateNumber(params[0]).message
                    },  // optional
                }
            }
        });
    }

    /* This lifecycle hook gets executed when the component mounts */
    componentDidMount() {
        this.fetchOrgs();
    }

    handleDateChange = (selectedDate, modifiers, dayPickerInput) => {
        const {name} = dayPickerInput.props;
        this.setState(prevState => ({
            newUser: {
                ...prevState.newUser,
                [name]: selectedDate
            }
        }));
    };

    handleRadioChange = e => {
        let name = e.target.name;
        let value = e.target.value;
        this.setState(prevState => ({
            newUser: {
                ...prevState.newUser,
                [name]: value
            }
        }));
    };

    handleInputChange = e => {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(prevState => ({
            newUser: {
                ...prevState.newUser,
                [name]: value
            }
        }));
    };

    handleCheckBox = e => {
        const {name, value} = e.target;
        const {newUser} = this.state;
        let values = newUser[name] || [];
        if (values.indexOf(value) > -1) {
            values = values.filter(s => s !== value);
        } else {
            values.push(value);
        }

        this.setState(prevState => ({
            newUser: {...prevState.newUser, [name]: values}
        }));
    };

    handleOrgChange = e => {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(prevState => {
            const {orgOptions} = prevState;
            const fifeOrg = orgOptions.find(org => org.description === "Fife");
            let isFife = false;
            if (fifeOrg) {
                isFife = String(fifeOrg.id) === String(value);
            }
            return {
                newUser: {
                    ...prevState.newUser,
                    [name]: value
                },
                isFife
            };
        }, this.fetchServices);
    };

    handleServiceChange = e => {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(
            prevState => ({
                newUser: {
                    ...prevState.newUser,
                    [name]: value
                }
            }),
            this.fetchDepts
        );
    };

    handleFormSubmit = e => {
        e.preventDefault();

        const {csrfToken, parentDomain} = this.props;
        let userData = this.state.newUser;

        this.setState({initialState: false});

        // check some methods here to ensure we never send 'other' data if the linked question doesn't show it
        if (!this.isNotSelfReferral()) {
            delete userData.employeeCounsellingConsent;
            delete userData.employeeContactConsent;
            delete userData.referrerName;
            delete userData.referrerContactInfo;
            delete userData.supportProvided;
        }

        FetchHelper.fetchWithPost({
            context: this,
            csrfToken,
            parentDomain,
            type: "tft",
            body: userData
        });
    };

    fetchOrgs = () => {
        this.setState({orgsLoading: true});

        fetch("/v1/organisations/organisations", {
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": this.props.csrfToken
            }
        })
            .then(response => {
                return response.json().then(data => {
                    return {
                        data: data,
                        status: response.status
                    };
                });
            })
            .then(response => {
                switch (response.status) {
                    case 200:
                        this.setState({
                            // need to expand on this logic for service and department
                            allOrgs: response.data,
                            orgOptions: response.data.filter(e => e.parent_id === null),
                            orgsLoading: false
                        });
                        break;
                    default:
                        console.log("Unexpected status: " + response.status);
                        window.location.assign("/500.html");
                }
            })
            .catch(({exception}) => {
                this.setState({loading: false});
                console.log(exception);
                window.location.assign("/500.html");
            });
    };

    fetchServices = () => {
        const {allOrgs} = this.state;

        this.setState({
            deptOptions: [],
            serviceOptions: (allOrgs || []).filter(
                e => e.parent_id === parseInt(this.state.newUser.organisation)
            )
        });
    };

    fetchDepts = () => {
        const {allOrgs} = this.state;

        this.setState({
            deptOptions: (allOrgs || []).filter(
                e => e.parent_id === parseInt(this.state.newUser.service)
            )
        });
    };

    renderSubmitButton = () => {
        const {initialState, loading} = this.state;
        const valid = initialState || this.validator.allValid();
        return (
            <>
                {!valid && (
                    <div className="alert alert-danger">
                        There are unresolved form errors, please correct the form before
                        resubmitting.
                    </div>
                )}
                <Button
                    type="submit"
                    className="btn-primary"
                    disabled={!valid || loading}
                >
                    Submit
                </Button>
            </>
        );
    };

    isNotSelfReferral = () => {
        const {selfReferral} = this.state.newUser;
        return selfReferral === "No";
    };

    isPersonalIssueGroup = () => {
        const {issueGroup} = this.state.newUser;
        return issueGroup === "Personal" || issueGroup === "Both";
    }

    isWorkIssueGroup = () => {
        const {issueGroup} = this.state.newUser;
        return issueGroup === "Work" || issueGroup === "Both";
    }

    render() {
        const {
            selfReferral,
            employeeCounsellingConsent,
            employeeContactConsent,
            referrerName,
            referrerContactInfo,
            supportProvided,
            email,
            jobTitle,
            jobType,
            firstName,
            lastName,
            gender,
            address1,
            address2,
            address3,
            address4,
            address5,
            postcode,
            dateOfBirth,
            homeTelephone,
            mobileTelephone,
            workTelephone,
            methodOfSupport,
            offWork,
            issueGroup,
            issuePersonalGroup,
            issueWorkGroup,
            organisation,
            service,
            department,
            costCode,
            tftConfirmation,
            howDidYouHear,
            referrer,
            lengthOfService,
            professionalMixIds,
            receivedCounselling,
            additionalReferralInfo,
            physicalDisabilities,
            supportAvailability,
            supportType,
        } = this.state.newUser;

        const {
            orgOptions,
            orgsLoading,
            serviceOptions,
            deptOptions,
            genderOptions,
            fullPartTimeOptions,
            radioOptions,
            enquiryOptions,
            submitted,
            isFife,
            howHearOptions,
            referrerOptions,
            lengthOfServiceOptions,
            professionalMixOptions,
            issueGroupOptions,
            issuePersonalGroupOptions,
            issueWorkGroupOptions,
            supportTypeOptions,
        } = this.state;

        let costCodeValidator = "alpha_num_space";
        if (isFife) {
            costCodeValidator = "required|alpha_num_space";
        }

        // ensure conditional fields are validated properly
        // https://www.npmjs.com/package/simple-react-validator#3-conditional-fields
        this.validator.purgeFields();

        return (
            <div className="container">
                <h1>
                    TimeforThriving Referral Form
                    <small>
                        Referral form for support via the Employee Assistance Programme
                    </small>
                </h1>
                <div className="row justify-content-start">
                    {submitted ? (
                        <Confirmation
                            referralType="tft"
                            returnCallback={() => {
                                this.setState({
                                    submitted: false,
                                    newUser: {system: "TFT"},
                                    initialState: true
                                });
                            }}
                        />
                    ) : (
                        <form className="col-8" onSubmit={this.handleFormSubmit} noValidate>
                            <div className="alert alert-secondary">
                                <p>
                                    Fields marked with <span className="required-field">*</span>{" "}
                                    are mandatory.
                                </p>
                            </div>

                            <div className="form-group">
                                <RadioButton
                                    label="Is this a self referral?"
                                    name="selfReferral"
                                    options={radioOptions}
                                    value={selfReferral}
                                    onChange={this.handleInputChange}
                                    required={true}
                                />{" "}
                                {this.validator.message(
                                    "self referral",
                                    selfReferral,
                                    "required"
                                )}
                            </div>

                            {selfReferral && selfReferral != "Yes" && (
                                <>
                                    <div className="form-group">
                                        <RadioButton
                                            label="Does employee consent to counselling?"
                                            name="employeeCounsellingConsent"
                                            options={radioOptions}
                                            value={employeeCounsellingConsent}
                                            onChange={this.handleInputChange}
                                            required={true}
                                        />{" "}
                                        {this.validator.message(
                                            "does employee consent to counselling",
                                            employeeCounsellingConsent,
                                            "required"
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <RadioButton
                                            label="Does employee consent for their contact details to be given to a counsellor in their local area?"
                                            name="employeeContactConsent"
                                            options={radioOptions}
                                            value={employeeContactConsent}
                                            onChange={this.handleInputChange}
                                            required={true}
                                        />{" "}
                                        {this.validator.message(
                                            "does employee consent for their contact details to be given to a counsellor in their local area",
                                            employeeCounsellingConsent,
                                            "required"
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <Input
                                            label="Referrer's name"
                                            name="referrerName"
                                            value={referrerName}
                                            required={true}
                                            onChange={this.handleInputChange}
                                        />{" "}
                                        {this.validator.message(
                                            "referrer's name",
                                            referrerName,
                                            "required"
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <Input
                                            label="Referrer's contact information"
                                            name="referrerContactInfo"
                                            value={referrerContactInfo}
                                            required={true}
                                            onChange={this.handleInputChange}
                                        />{" "}
                                        {this.validator.message(
                                            "referrer's contact information",
                                            referrerContactInfo,
                                            "required"
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <Input
                                            label="Support currently being provided to employee, if any"
                                            name="supportProvided"
                                            value={supportProvided}
                                            required={true}
                                            onChange={this.handleInputChange}
                                        />{" "}
                                        {this.validator.message(
                                            "support currently being provided to employee, if any",
                                            supportProvided,
                                            "required"
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <Select
                                            label="Referrer"
                                            name="referrer"
                                            options={referrerOptions}
                                            value={referrer}
                                            placeholder={"Select one"}
                                            required={true}
                                            handleChange={this.handleInputChange}
                                        />{" "}
                                        {this.validator.message("referrer", referrer, 'required')}
                                    </div>                                    
                                </>
                            )}

                            <div className="alert alert-secondary">
                                <p>
                                    If this is a self referral, please enter your own details. If
                                    this is an employer referral, please enter the employee's
                                    details.
                                </p>
                            </div>

                            <div className="form-group">
                                <EmailInput
                                    label={"Email address"}
                                    name="email"
                                    id="email"
                                    value={email}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message("email", email, "required|email")}
                            </div>

                            <div className="form-group">
                                <Input
                                    inputtype={"text"}
                                    label="First Name"
                                    name="firstName"
                                    value={firstName}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message(
                                    "first name",
                                    firstName,
                                    "required|alpha_space"
                                )}
                            </div>

                            <div className="form-group">
                                <Input
                                    inputtype={"text"}
                                    label="Last Name"
                                    name="lastName"
                                    value={lastName}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message(
                                    "last name",
                                    lastName,
                                    "required|alpha_space"
                                )}
                            </div>

                            <div className="form-group">
                                <Input
                                    name="dateOfBirth"
                                    label="Date of Birth (DD/MM/YYYY)"
                                    value={dateOfBirth}
                                    type="date"
                                    onChange={this.handleInputChange}
                                    required={true}
                                />{" "}
                                {this.validator.message(
                                    "date of birth",
                                    dateOfBirth,
                                    "required"
                                )}
                            </div>

                            <h2>Address</h2>
                            <div className="form-group">
                                <Input
                                    name="address1"
                                    label="Line 1"
                                    value={address1}
                                    placeholder={"House Name/Number"}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message("address line 1", address1, "required")}
                            </div>
                            <div className="form-group">
                                <Input
                                    name="address2"
                                    label="Line 2"
                                    value={address2}
                                    placeholder={"Street"}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="address3"
                                    label="Line 3"
                                    value={address3}
                                    placeholder={"Area"}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="address4"
                                    label="Line 4"
                                    value={address4}
                                    placeholder={"Town"}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="address5"
                                    label="Line 5"
                                    value={address5}
                                    placeholder={"County"}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="postcode"
                                    label="Postcode"
                                    value={postcode}
                                    placeholder={"Postcode"}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message(
                                    "address line 6",
                                    postcode,
                                    "required|alpha_num_space"
                                )}
                            </div>

                            <div className="form-group">
                                <TelephoneInput
                                    name="homeTelephone"
                                    label="Home Telephone"
                                    value={homeTelephone}
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message(
                                    "home telephone",
                                    homeTelephone,
                                    `custom_phone_number:${homeTelephone}`,
                                )}
                            </div>

                            <div className="form-group">
                                <TelephoneInput
                                    name="mobileTelephone"
                                    label="Mobile Telephone"
                                    value={mobileTelephone}
                                    required={true}
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message(
                                    "mobile telephone",
                                    mobileTelephone,
                                    `required|custom_phone_number:${mobileTelephone},mobile`
                                )}
                            </div>

                            <div className="form-group">
                                <TelephoneInput
                                    name="workTelephone"
                                    label="Work Telephone"
                                    value={workTelephone}
                                    onChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message(
                                    "work telephone",
                                    workTelephone,
                                    `custom_phone_number:${workTelephone}`,
                                )}
                            </div>

                            <div className="form-group">
                                <RadioButton
                                    label="Gender"
                                    name="gender"
                                    options={genderOptions}
                                    value={gender}
                                    onChange={this.handleInputChange}
                                    required={true}
                                />{" "}
                                {this.validator.message("gender", gender, "required")}
                            </div>

                            <div className="form-group">
                                <RadioButton
                                    label="What type of support is required?"
                                    name="methodOfSupport"
                                    options={enquiryOptions}
                                    value={methodOfSupport}
                                    onChange={this.handleInputChange}
                                    required={true}
                                />{" "}
                                {this.validator.message(
                                    "what type of support is required",
                                    methodOfSupport,
                                    "required"
                                )}
                            </div>

                            <div className="form-group">
                                <RadioButton
                                    label="Currently off work?"
                                    name="offWork"
                                    options={radioOptions}
                                    value={offWork}
                                    onChange={this.handleInputChange}
                                    required={true}
                                />{" "}
                                {this.validator.message(
                                    "currently off work",
                                    offWork,
                                    "required"
                                )}
                            </div>

                            <div className="form-group">
                                <Input
                                    label="Job title"
                                    name="jobTitle"
                                    value={jobTitle}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <RadioButton
                                    label="Job type"
                                    name="jobType"
                                    options={fullPartTimeOptions}
                                    value={jobType}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            <div className="form-group">
                                <RadioButton
                                    label="Length of service with Employer"
                                    name="lengthOfService"
                                    options={lengthOfServiceOptions}
                                    value={lengthOfService}
                                    onChange={this.handleInputChange}
                                    required={true}
                                />{" "}
                                {this.validator.message(
                                    "length of service with employer",
                                    lengthOfService,
                                    "required"
                                )}
                            </div>

                            <div className="form-group">
                                <Select
                                    label="Organisation"
                                    name="organisation"
                                    options={orgOptions}
                                    value={organisation}
                                    placeholder={"Select Organisation"}
                                    handleChange={this.handleOrgChange}
                                    loading={orgsLoading}
                                    required
                                />{" "}
                                {this.validator.message(
                                    "organisation",
                                    organisation,
                                    "required"
                                )}
                            </div>

                            <div className="form-group">
                                <Select
                                    label="Service"
                                    name="service"
                                    options={serviceOptions}
                                    value={service}
                                    placeholder={"Select Service"}
                                    required
                                    handleChange={this.handleServiceChange}
                                />{" "}
                                {this.validator.message("service", service, "required")}
                            </div>

                            <div className="form-group">
                                <Select
                                    label="Department"
                                    name="department"
                                    options={deptOptions}
                                    value={department}
                                    placeholder={"Select Department"}
                                    required
                                    handleChange={this.handleInputChange}
                                />{" "}
                                {this.validator.message("department", department, "required")}
                            </div>

                            <div className="form-group">
                                <Input
                                    type={"text"}
                                    label="Cost code/unique identifier/employee number"
                                    name="costCode"
                                    value={costCode}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                            {this.validator.message("cost code/unique identifier/employee number", costCode, costCodeValidator)}

                            <div className="form-group">
                                <Select
                                    label="How did you hear about us?"
                                    name="howDidYouHear"
                                    options={howHearOptions}
                                    value={howDidYouHear}
                                    placeholder={"Select one"}
                                    handleChange={this.handleInputChange}
                                />
                            </div>

                            <div className="form-group">
                                <CheckBox
                                    name="professionalMixIds"
                                    label="Professional mix (Swansea University staff only)"
                                    onChange={this.handleCheckBox}
                                    options={professionalMixOptions}
                                    selectedOptions={professionalMixIds}
                                />
                            </div>

                            <div className="form-group">
                                <RadioButton
                                    name="issueGroup"
                                    label="Reason for Referral"
                                    required
                                    onChange={this.handleInputChange}
                                    options={issueGroupOptions}
                                    value={issueGroup}
                                />{" "}
                                {this.validator.message("reason for referral", issueGroup, "required")}
                            </div>

                            {this.isPersonalIssueGroup() && (
                                <div className="form-group">
                                    <Select
                                        name="issuePersonalGroup"
                                        label="Personal reason"
                                        required
                                        handleChange={this.handleInputChange}
                                        options={issuePersonalGroupOptions}
                                        placeholder={"Select one"}
                                        value={issuePersonalGroup}
                                    />{" "}
                                    {this.validator.message("personal reason", issuePersonalGroup, "required")}
                                </div>
                            )}

                            {this.isWorkIssueGroup() && (
                                <div className="form-group">
                                    <Select
                                        name="issueWorkGroup"
                                        label="Work reason"
                                        required
                                        handleChange={this.handleInputChange}
                                        options={issueWorkGroupOptions}
                                        placeholder={"Select one"}
                                        value={issueWorkGroup}
                                    />{" "}
                                    {this.validator.message("work reason", issueWorkGroup, "required")}
                                </div>
                            )}
                            
                            <div className="form-group">
                                <Input
                                    label="Additional Referral information"
                                    name="additionalReferralInfo"
                                    value={additionalReferralInfo}
                                    onChange={this.handleInputChange}
                                />
                            </div>

                            <div className="form-group">
                                <RadioButton
                                    label="Received support from TimeforThriving previously?"
                                    name="receivedCounselling"
                                    options={radioOptions}
                                    value={receivedCounselling}
                                    onChange={this.handleInputChange}
                                />
                            </div>

                            <div className="form-group">
                                <TextArea
                                    label="Physical disabilities"
                                    name="physicalDisabilities"
                                    value={physicalDisabilities}
                                    maxLength={2000}
                                    onChange={this.handleInputChange}
                                />
                            </div>

                            <div className="form-group">
                                <TextArea
                                    label="Availability for support"
                                    name="supportAvailability"
                                    value={supportAvailability}
                                    maxLength={2000}
                                    onChange={this.handleInputChange}
                                />
                            </div>

                            <div className="form-group">
                                <Select
                                    label="Type of Support"
                                    name="supportType"
                                    options={supportTypeOptions}
                                    value={supportType}
                                    placeholder={"Select one"}
                                    handleChange={this.handleInputChange}
                                />
                            </div>

                            <hr />

                            <div className="form-group">
                                <CheckBox
                                    label="
                    This statement is for those who are accessing our services for themselves
                    or on behalf of another person (i.e. making a referral) If you are accessing
                    the services for yourself, please read this statement because it sets out what
                    you are consenting to. If you are referring someone to receive confidential support
                    please read and confirm. To process this referral and put in place psychological wellbeing
                    support, the organisation requires the information which is to be entered into the referral form.
                    This is personal information covered under the GDPR regulations and therefore it is a requirement
                    that the person who is being referred has consented to the personal information being shared with this
                    organisation. The data is confidential and not shared with others, but we retain the right to use this
                    information to contact others if we believe the person receiving our support (or others) is in danger or
                    at risk of abuse. As far as possible we will seek consent before taking this action, but the safety of
                    those we support is our priority.
                "
                                    helpText="If the support is for you then it is necessary to confirm that you
                    understand this statement. If the referral is being made on behalf of another, then the person making
                    the referral must confirm that the consent of the person has been sought and received."
                                    name="tftConfirmation"
                                    options={["I agree"]}
                                    selectedOptions={tftConfirmation}
                                    onChange={this.handleCheckBox}
                                    required={true}
                                />
                                {this.validator.message(
                                    "agreement",
                                    tftConfirmation,
                                    "required"
                                )}
                            </div>

                            {this.renderSubmitButton()}
                        </form>
                    )}
                            <ResearchDisclaimer />
                </div>
            </div>
        );
    }
}

export default TFTReferral;
